var $8023290c23a790d8$exports = {};
$8023290c23a790d8$exports = {
    "pending": `avventer`
};


export {$8023290c23a790d8$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
